<div class="container p-3">
    <div class="row" [formGroup]="formGroup">
        <div class="col position-relative">
            <div style="position: absolute; top: 5px; right: 15px;">
                <a href="{{ watchfacesStore }}">
                    <i class="fas fa-external-link-alt"></i> {{ watchfacesStore }}
                </a>
            </div>
            <h3>Search watchfaces</h3>
            <div class="mb-3">
                <div class="input-group">
                    <input #searchInput type="text" placeholder="Search watchfaces..." class="form-control" maxlength="64" (keyup)="searchInputKeyUp(searchInput.value)" (keyup.enter)="searchWatchfaces()" formControlName="searchInput">
                    <button class="btn btn-primary" [class.progress-bar-striped]="searchInProgress" [class.progress-bar-animated]="searchInProgress" [disabled]="searchInProgress" (click)="searchWatchfaces()">
                        <div *ngIf="!searchInProgress">
                            <i class="fas fa-search"></i> Search
                        </div>
                        <div *ngIf="searchInProgress">
                            <i class="fas fa-hourglass-half"></i> Search
                        </div>
                    </button>
                </div>
            </div>
            <div class="mb-3">
                <div class="form-check form-check-inline">
                    <input type="checkbox" class="form-check-input" id="tagZeTimeCheckbox" formControlName="tagZeTimeCheckbox" (change)="searchWatchfaces()">
                    <label class="form-check-label" for="tagZeTimeCheckbox">ZeTime</label>
                </div>
                <div class="form-check form-check-inline">
                    <input type="checkbox" class="form-check-input" id="tagZeSport2Checkbox" formControlName="tagZeSport2Checkbox" (change)="searchWatchfaces()">
                    <label class="form-check-label" for="tagZeSport2Checkbox">ZeSport2</label>
                </div>
                <div class="form-check-inline d-inline-flex align-items-baseline">
                    <label class="form-label text-nowrap" for="createdAfterInput">Created after&nbsp;</label>
                    <input type="text" placeholder="yyyy-MM-dd" class="form-control" id="createdAfterInput" style="width: 8rem;" maxlength="10" formControlName="createdAfterInput" (change)="searchWatchfaces()">
                </div>
                <div class="form-check-inline d-inline-flex align-items-baseline">
                    <label class="form-label text-nowrap" for="createdBeforeInput">Created before&nbsp;</label>
                    <input type="text" placeholder="yyyy-MM-dd" class="form-control" id="createdBeforeInput" style="width: 8rem;" maxlength="10" formControlName="createdBeforeInput" (change)="searchWatchfaces()">
                </div>
            </div>
            <div class="mb-3">
                <div class="form-check form-check-inline">
                    <input type="checkbox" class="form-check-input" id="statusPendingCheckbox" formControlName="statusPendingCheckbox" (change)="searchWatchfaces()">
                    <label class="form-check-label" for="statusPendingCheckbox">Pending</label>
                </div>
                <div class="form-check form-check-inline">
                    <input type="checkbox" class="form-check-input" id="statusModifyCheckbox" formControlName="statusModifyCheckbox" (change)="searchWatchfaces()">
                    <label class="form-check-label" for="statusModifyCheckbox">Modify</label>
                </div>
                <div class="form-check form-check-inline">
                    <input type="checkbox" class="form-check-input" id="statusApprovedCheckbox" formControlName="statusApprovedCheckbox" (change)="searchWatchfaces()">
                    <label class="form-check-label" for="statusApprovedCheckbox">Approved</label>
                </div>
                <div class="form-check form-check-inline">
                    <input type="checkbox" class="form-check-input" id="statusRejectedCheckbox" formControlName="statusRejectedCheckbox" (change)="searchWatchfaces()">
                    <label class="form-check-label" for="statusRejectedCheckbox">Rejected</label>
                </div>
                <div class="form-check-inline d-inline-flex align-items-baseline">
                    <label class="form-label text-nowrap" for="minRatingSelect">Min stars&nbsp;</label>
                    <select id="minRatingSelect" class="form-select" formControlName="minStarsSelect" (change)="searchWatchfaces()">
                        <option [selected]="true">―</option>
                        <option value="0">0</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                    </select>
                </div>
                <div class="form-check-inline d-inline-flex align-items-baseline">
                    <label class="form-label text-nowrap" for="maxRatingSelect">Max stars&nbsp;</label>
                    <select id="maxRatingSelect" class="form-select" formControlName="maxStarsSelect" (change)="searchWatchfaces()">
                        <option [selected]="true">―</option>
                        <option value="0">0</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                    </select>
                </div>
                <div class="form-check-inline d-inline-flex align-items-baseline">
                    <label class="form-label text-nowrap" for="orderBySelect">Order by&nbsp;</label>
                    <select id="orderBySelect" class="form-select" formControlName="orderBySelect" (change)="searchWatchfaces()">
                        <option [selected]="true">―</option>
                        <option value="datetime">datetime</option>
                        <option value="downloads">downloads</option>
                        <option value="score">relevance</option>
                    </select>
                </div>
                <div class="form-check-inline" *ngIf="count != null && count >= 0">
                    <label class="form-label">({{ count }} {{ count > 1 ? 'results' : 'result' }})</label>
                </div>
            </div>
        </div>
    </div>
    <hr>
    <div class="row">
        <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3" style="padding-top: 15px; padding-bottom: 15px;" *ngFor="let watchface of watchfaces">
            <watchface-card [watchface]="watchface" (approve)="clickApproveWatchface(watchface)" (reject)="clickRejectWatchface(watchface)"></watchface-card>
        </div>
    </div>
    <div class="row" *ngIf="countLeft > 0">
        <div class="col text-center">
            <button class="btn btn-primary mx-auto" (click)="searchWatchfaces(watchfaces.length)" [disabled]="searchInProgress" [class.progress-bar-striped]="searchInProgress" [class.progress-bar-animated]="searchInProgress">
                <div *ngIf="!searchInProgress">
                    <i class="fas fa-step-forward" style="transform: rotate(90deg)"></i> Next
                </div>
                <div *ngIf="searchInProgress">
                    <i class="fas fa-hourglass-half"></i> Loading
                </div>
            </button>
        </div>
    </div>
</div>